import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WaterFertilizerComponent } from './waterFertilizer.component';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    SharedModule
  ],
  declarations: [WaterFertilizerComponent]
})
export class WaterFertilizerModule { }
